export class ValidationError extends Error {
  public readonly name: string = 'ValidationError';

  constructor(public message: string) {
    super(message);
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
